import { APP_BASE_HREF } from '@angular/common';
import { Component, ContentChild, ElementRef, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ObservableInput } from 'ngx-observable-input';
import { BehaviorSubject, combineLatest, empty, EMPTY, fromEvent, interval, merge, NEVER, Observable, of, ReplaySubject, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, startWith, switchMap, tap } from 'rxjs/operators';

import { v4 as uuidv4 } from 'uuid';
import { Color } from '@swimlane/ngx-charts';
import { Single } from '../../../interfaces/single.interface';


@Component({
  selector: 'pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.css']
})
export class PieChartComponent implements OnInit {

  @Input()
  options: PieChartOptions = null;

  @Output()
  select: EventEmitter<any> = new EventEmitter();

  @ContentChild('eveTooltipTemplate') eveTooltipTemplate: TemplateRef<any>;

  parentElement: any = null;


  scheme = {
    domain: ['#00abca', '#be0078', '#85bf75', '#c23133']
  };
  gradient: boolean = true;
  legend: boolean = true;
  legendPosition: string = 'right';
  legendTitle: string = "";
  labels: boolean = true;
  doughnut: boolean = true;

  @ObservableInput()
  @Input("results")
  results$: Observable<Single[]>;
  _results: Observable<Single[]>;


  excludeResults: BehaviorSubject<String[]> = new BehaviorSubject([]);

  parentWidth: Observable<number> = interval(10).pipe(
    map(() => this.parentElement.offsetWidth),
    distinctUntilChanged()
  );

  parentHeight: Observable<number> = interval(10).pipe(
    map(() => this.parentElement.offsetHeight),
    distinctUntilChanged()
  );

  view: Observable<number[]> = combineLatest(this.parentWidth, this.parentHeight).pipe(
    map(a => [a[0], a[1]]),
    debounceTime(15)
  );

  legendStyles: Observable<SafeHtml> = this.excludeResults.pipe(
    map(excludeResult => {
      return this.sanitizer.bypassSecurityTrustHtml(excludeResult.map((e, p) => `<style>
      .${this.componenetId} ngx-charts-legend-entry [title="${e}"] {
        opacity: 0.2;
      }
    </style>`
      ).join("\r\n"))
    })
  );

  componenetId: String = "componenetId_" + uuidv4().replaceAll("-", "");
 

  constructor(
    private elRef: ElementRef,
    private sanitizer: DomSanitizer
  ) {

  }




  ngOnInit() {

    this.elRef.nativeElement.classList.add(this.componenetId);

    this.parentElement = this.elRef.nativeElement;
    this._results = this.results$.pipe(
      //NgxMultiExcludes(this.excludeResults)

    );

  }





  onSelect(data, results): void {
    if (!this.isLegend(data)) {
      const result = results.find(r => r.name == data.name);
      this.select.emit(result);
    } else {
      const excludeResults = this.excludeResults.getValue()

      if (excludeResults.indexOf(data) == -1) this.excludeResults.next(excludeResults.concat([data]));
      else this.excludeResults.next(excludeResults.filter(i => i != data));
    }

  }

  isLegend = (event) => typeof event === 'string';



  onActivate(data): void {
  }

  onDeactivate(data): void {
  }





}


export interface PieChartOptions {
  width: number,
  height: number,
  chartHeader?: string,
  colourScheme: string | Color
}
